<template>
    <ul ref="switcher" uk-tab="connect: #component-tab-left; animation: uk-animation-fade; media: @m" :class="{'uk-tab-left': !small && twoColumns}">
        <li :class="{'uk-active': currentStep === 0}">
            <a href="#" @click="$emit('updatePage', 0)">{{ $t("Ticket wählen") }}</a>
        </li>
        <li v-show="hasTickets && personalizable" :class="{'uk-active': currentStep === 1}">
            <a href="#" @click="$emit('updatePage', 1)">{{$t("Personalisieren")}}</a>
        </li>
        <li v-show="hasTickets && personalizabled" :class="{'uk-active': currentStep === 2}">
            <a href="#" @click="$emit('updatePage', 2)">{{$t("Checkout")}}</a>
        </li>
        <li v-show="allDataCollected" :class="{'uk-active': currentStep === 3}">
            <a href="#" @click="$emit('updatePage', 3)">{{$t("Zusammenfassung")}}</a>
        </li>
    </ul>
</template>

<script>
import helper from "../helper/helper";

export default {
    mixins: [helper],
    props: ['currentStep', 'twoColumns', 'small'],
    data: () => {
        return {
        }
    },
    computed: {
        hasTickets() {
            return Object.keys(this.store.state.selection).length
        },
        personalizable() {
            return this.store.state.personalize && !this.store.state.onlyNoChipTicketsSelected
        },
        personalizabled() {
            return !this.store.state.personalize || (this.store.state.personalize && this.store.state.personalized)
        },
        allDataCollected() {
            return this.store.state.allDataCollected;
        }
    },
    mounted() {
    },
    methods: {

    }
}
</script>
